<template>
  <BoxWithTitle>
    <template #header>
      <v-toolbar-title>
        {{ $t('products.info') }}
      </v-toolbar-title>
    </template>
    <template
      v-if="hasPermission('products.edit')"
      #icons
    >
      <v-btn
        icon
        @click="onClickToggle"
      >
        <v-icon>
          {{ formEditable ? 'mdi-close' : 'mdi-pencil-outline' }}
        </v-icon>
      </v-btn>
    </template>
    <template #content>
      <form v-if="hasPermission('products.view')">
        <ProductForm
          :populateWith="updatedData"
          :isEditable="formEditable"
          @dirtyChanged="isFormDirty = $event"
          @validChanged="isFormValid = $event"
          @sendData="updateData"
        />
        <v-row
          v-if="formEditable"
          align="center"
          justify="end"
          class="mr-1"
        >
          <v-btn
            :disabled="!isFormValid || !isFormDirty"
            type="submit"
            color="secondary"
            @click.prevent="onClickUpdate"
          >
            {{ $t('forms.btn.save') }}
          </v-btn>
          <v-btn
            text
            @click.prevent="onClickDelete"
          >
            <span class="text-danger">
              {{ $t('forms.btn.delete') }}
            </span>
          </v-btn>
        </v-row>
      </form>
    </template>
  </BoxWithTitle>
</template>

<script>
import { cloneDeep } from 'lodash';
import { mapGetters, mapActions } from 'vuex';
import EditableFormStateMixin from '@/mixins/EditableFormStateMixin';
import ProductForm from '@/components/forms/ProductForm.vue';
import BoxWithTitle from '@/components/shared/containers/VBoxWithTitle.vue';

export default {
    components: {
        ProductForm,
        BoxWithTitle,
    },
    mixins: [
        EditableFormStateMixin,
    ],
    data() {
        return {
            defaultData: null,
            updatedData: null,
        };
    },
    computed: {
        ...mapGetters([
            'product',
            'hasPermission',
        ]),
    },
    created() {
        this.defaultData = cloneDeep(this.product);
        this.updatedData = cloneDeep(this.product);
    },
    methods: {
        ...mapActions({
            reloadProduct: 'getProductInfo',
        }),
        async onClickUpdate() {
            const requestPayload = this.$utils.getObjectsDifference(this.updatedData, this.defaultData);

            const request = new FormData();
            Object.keys(requestPayload).forEach(key => {
                request.append(key, requestPayload[key]);
            });

            const { id, name } = this.updatedData;

            await this.$rq.updateProduct(id, request);
            await this.reloadProduct(id);

            this.$toasted.global.toast_success({
                message: this.$t('msg.productModified', { data: name }),
            });

            await this.$router.push({ name: 'products' });
        },
        async onClickDelete() {
            await this.$rq.deleteProduct(this.product.id);
            this.$toasted.global.toast_success({
                message: this.$t('msg.productRemoved', { data: this.product.name }),
            });
            await this.$router.push({ name: 'productsPage' });
        },
    },
};
</script>
